import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  clone,
  pullAt,
  findLastIndex,
  isArray,
} from 'lodash';
import API from '../../api';
import TablePartners from '../VibeTable/Tables/TablePartners';
import './PartnersUnassigned.scss';

class PartnersUnassigned extends PureComponent {
  constructor(props) {
    super(props);

    const {
      selected,
    } = props;

    this.state = {
      selected,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      selected,
    } = this.props;

    const {
      selected: prevSelected,
    } = prevProps;

    if (JSON.stringify(selected) !== JSON.stringify(prevSelected)) {
      this.setState({
        selected,
      });
    }
  }

  onAdd = (items) => {
    const {
      onChange,
    } = this.props;

    if (!isArray(items)) {
      items = [items];
    }

    const newItems = items.map((item) => {
      const newItem = clone(item);

      // remove the row ID to give it a unique identifier
      delete newItem._rowId;
      return newItem;
    });

    this.setState((state) => {
      const items = [
        ...state.selected,
        ...newItems,
      ];

      onChange(items);

      return {
        selected: items,
      };
    });
  };

  onRemove = (item) => {
    const {
      onChange,
    } = this.props;

    this.setState((state) => {
      const {
        selected,
      } = state;

      const lastIndex = findLastIndex(selected, { _id: item._id });

      // only remove one item in case there are duplicates
      pullAt(selected, lastIndex);
      onChange(selected);

      return {
        selected,
      };
    });

    // needed because the third panel table isn't re-rendered on a prop/state change
    document.dispatchEvent(new Event('onRenderTable'));
    document.dispatchEvent(new Event('onUpdateTableAssignedPartners'));
  };

  render() {
    const {
      user,
      customToolbar,
      filters,
      onChange,
    } = this.props;

    const {
      selected,
    } = this.state;

    return (
      <div className="PartnersUnassigned">
        <div className="title-container">
          <div className="title">
            Available Partners
          </div>

          {customToolbar}
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <TablePartners
            columns={[
              'Add/Remove',
              'Name',
              'Company',
              'Tags',
              '...',
            ]}
            fetch={API.Partner.list}
            fetchProps={{
              filters: {
                _id: user._id,
              },
            }}
            filters={filters}
            defaultSortBy={{
              label: 'Name',
              attr: 'name',
              direction: 'asc',
            }}
            paginator
            paginatorProps={{
              label: 'Partners',
              urlPaging: false,
              urlFilters: false,
            }}
            available
            highlight={selected}
            onAdd={this.onAdd}
            onRemove={this.onRemove}
            onChange={onChange}
          />
        </div>
      </div>
    );
  }
}

PartnersUnassigned.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    messageType: PropTypes.string,
    url: PropTypes.string,
    active: PropTypes.bool,
  })),
  /** Filters for the fetch method */
  filters: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  /** Custom toolbar */
  customToolbar: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** When the messages are changed */
  onChange: PropTypes.func,
};

PartnersUnassigned.defaultProps = {
  filters: null,
  selected: [],
  customToolbar: null,
  onChange: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(PartnersUnassigned);
